import React from 'react'

export default function CustomerCreatePage() {
  return (
    <div>
      <h2>Create Customer</h2>
      <form>
        <div className="form-group">
          <label>Name</label>
          <input className="form-control" placeholder="Customer name" />
        </div>
        <button className="btn btn-primary">Save</button>
      </form>
    </div>
  )
}
